<template>
    <div class='body-main'>
        <div class='cart-header'>
            <div class='cart-header-warp clearfix'>
                <div class='cart-title left clearfix'>
                    <h1 class='left'>支付中心</h1>
                </div>
                <div class='right'>


                </div>
            </div>
        </div>
        <div class='cart-body'>
            <div class='cart-body-title'>

                <div class='clearfix'>
                    <div class='left trade-title'>
                        <span class='order'>订单：</span><span class='num'>{{this.$route.params.id}}</span>
                    </div>
                    <div class='right'>
                        <a href='javascript:void(0);' @click="datashow" class='js-toggle-detai'>{{showmsg}}</a>
                    </div>
                </div>

                <ul class='js-itemUl item-ul'>
                    <li class='clearfix'>
                        <paytable v-show="isshow" v-bind:indentdata="indentid"/>
                    </li>
                </ul>

            </div>
            <div class='pay-method'>
                <h2 class='pay-method-title'>支付方式</h2>
                <ul class='clearfix js-pay-method'>
                    <li class='pay-way alipay' v-bind:class="{active : paysty == 1}" @click="paysty = 1">
                        <div class='bottomright'>
                            <div class='triangle'></div>
                            <i class='imv2-check'></i>
                        </div>
                    </li>
                    <li class='pay-way wxpay' v-bind:class="{active : paysty == 2}" @click="paysty = 1">
                        <div class='bottomright'>
                            <div class='triangle'></div>
                            <i class='imv2-check'></i>
                        </div>
                    </li>
                </ul>

            </div>
            <div class='pay-summary clearfix huabei-active'>
                <div class='warning'>
                    <i class='imv2-error_c'></i>
                    <span>可在 <b><a class="dingdana" href="/Ordercenter">订单中心</a></b> 查看此订单！</span>
                </div>

                <div class='summary'>
                    <div class='clearfix total'>
                        <span class='label'>应付金额：</span>
                        <span class='price'>
					<em>￥</em>
					<span>{{totalMoney | formats}}</span>
				</span>
                    </div>

                    <div class='submit-warp clearfix'>
                        <span data-ordernum='1807160919548242'
                              class="r moco-btn-red submit-btn js-pay-submit" @click="gopayment">立即支付</span>
                    </div>

                    <div class='clearfix feedback-href'>
                        <a target="_blank" href='javascript:void(0);'>我有疑问，需要反馈？</a>
                    </div>

                </div>
            </div>
        </div>

        <el-dialog
                title=""
                :visible.sync="weixinzhifulog"
                width="350px"
                :close-on-press-escape="false"
                :show-close="false"
                :close-on-click-modal="false"
                center>
            <h1 class="price">微信支付￥<span>{{totalMoney | formats}}</span></h1>
            <qriously :value="initQCode" :size="180" style="text-align: center;margin: 12px auto;"/>
            <p class="paypa">使用微信扫描二维码进行支付</p>
            <p class="paypb" @click="chongxinxuanze">重新选择支付方式</p>

        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import Paytable from "./paytable";


    export default {
        name: "payfortheorder",
        components:
            {
                Paytable,
                axios,

            }
        ,
        data() {
            return {
                tableData: [],
                totalMoney: 0,
                totalNumber: 0,
                paydata: {},
                indentid: [],
                isshow: false,
                showmsg: '详情',
                paysty: 1,//支付方式 1 支付宝 2 微信 3 现金汇款
                weixinzhifulog: false,
                initQCode: '',
                mysettime: null,
            }
        }, methods: {
            datashow() {
                if (this.isshow) {
                    this.showmsg = '详情';
                    this.isshow = false;
                } else {
                    this.showmsg = '收起';
                    this.isshow = true;
                }
            },
            //立即支付
            gopayment() {
                if (this.paysty == 1) {
                    this.$message({
                        showClose: true,
                        message: "还未开通此支付",
                        type: 'error',
                        duration: 10000
                    });
                } else if (this.paysty == 2) {
                    //微信支付的信息
                    var paydata = {
                        "out_trade_no": this.paydata.ordernub
                    };
                    axios.post("/apiWei/pay", paydata).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                //发起支付成功
                                this.initQCode = res.data.code_url;
                                this.weixinzhifulog = true;
                                this.mysettime = setInterval(this.getInterval, 1500);
                            } else {
                                //发起支付返回失败
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error',
                                    duration: 10000
                                });
                            }
                        } else {
                            //发起支付失败
                            this.$message({
                                showClose: true,
                                message: "发起支付失败,请重试！",
                                type: 'error',
                                duration: 10000
                            });
                        }
                    })
                }
            },
            //重新选择支付方式
            chongxinxuanze() {
                this.weixinzhifulog = false;
                clearInterval(this.mysettime);
                this.mysettime = null;
            },
            //轮询获取数据
            getInterval() {
                axios.post("/apiWei/getpayreceiptdata", {"out_trade_no": this.paydata.ordernub}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            clearInterval(this.mysettime);
                            this.mysettime = null;
                            this.$message({
                                showClose: true,
                                message: "支付成功！！！",
                                type: 'success',
                                duration: 20000
                            });
                            this.$confirm('支付成功！请点击完成支付进入订单页面。', '提示', {
                                confirmButtonText: '完成支付',
                                type: 'success',
                                showClose: false,
                                center: true
                            }).then(() => {
                                this.$router.push({
                                    name: 'Ordercenter',
                                })
                            });

                        }
                    }

                });
            },

        },
        mounted() {
            if (this.$route.params.id == null) {
                this.$router.push({
                    name: 'Cart',
                })
            } else {
                axios.post("/Api/admin/getpayforthorderdata", {id: this.$route.params.id}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.paydata = res.data.data;
                            this.totalMoney = res.data.data.price;
                            this.indentid = res.data.data.indentid;
                            axios.post("/Api/admin/getStoreNumber").then(res => {
                                if (res.statusText == "OK") {
                                    if (res.data.errcode == 0) {
                                        this.$store.commit('upcartCount', res.data.data);
                                    } else {
                                        this.$store.commit('upcartCount', 0);
                                    }
                                }
                            });
                        } else if (res.data.errcode == 40000) {
                            this.$router.push({
                                name: 'Cart',
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 10000
                            });
                        }
                    } else {
                        //操作失败
                        this.$message({
                            showClose: true,
                            message: '获取数据失败，请重新登入！',
                            type: 'error',
                            duration: 10000
                        });
                    }
                });
            }
        },
        filters: {  //数据过滤器
            formats: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return value + ".00";
                }
                _val = value.split('.');
                return _val[0] + '.' + _val[1];
            }
        }
    }
</script>

<style>
    .cart-body .pay-method {
        padding: 30px 12px 48px;
        border-top: 1px solid #d9dde1;
        border-bottom: 1px solid #d9dde1;
    }

    .cart-body .pay-method .pay-method-title {
        height: 46px;
        line-height: 30px;
        font-size: 16px;
        color: #07111b;
    }

    ol, ul {
        list-style: none;
    }

    .cart-body .pay-method li {
        float: left;
        margin-right: 25px;
        position: relative;
        width: 236px;
        height: 86px;
        background-color: #f3f5f7;
        border: 2px solid #f3f5f7;
        cursor: pointer;
        background-image: url(../assets/img/pay_s.png);
    }

    .cart-body .pay-method .pay-way.active {
        border-color: #f01414;
    }

    .cart-body .pay-method .alipay {
        background-position: 55px -304px;
        background-repeat: no-repeat;
    }

    .cart-body .pay-method .wxpay {
        background-position: 48px -423px;
        background-repeat: no-repeat;
    }

    .cart-body .pay-summary .warning {
        font-size: 14px;
        color: #f90;
        padding-top: 32px;
        line-height: 20px;
        float: left;
    }

    .cart-body .pay-summary i {
        font-size: 20px;
        position: relative;
        top: 3px;
    }

    .cart-body .pay-summary .warning {
        font-size: 14px;
        color: #f90;
        padding-top: 32px;
        line-height: 20px;
        float: left;
    }

    .cart-body .pay-summary .summary {
        float: right;
        padding-top: 36px;
    }

    .cart-body .pay-summary .total {
        height: 24px;
    }

    .cart-body .pay-summary .label {
        width: 96px;
        font-size: 14px;
        color: #07111b;
        height: 20px;
        text-align: right;
        float: left;
        line-height: 20px;
    }

    .cart-body .pay-summary .total .price {
        font-size: 24px;
        line-height: 24px;
        height: 24px;
    }

    .cart-body .pay-summary .price {
        font-size: 14px;
        color: #f01414;
        height: 20px;
        text-align: right;
        line-height: 20px;
        float: left;
    }

    .cart-body .pay-summary .submit-warp {
        margin-top: 32px;
        margin-bottom: 16px;
    }

    .cart-body .pay-summary .feedback-href a {
        float: right;
        font-size: 12px;
        color: #4d555d;
    }

    .submit-btn {
        padding: 0;
        width: 140px;
        height: 40px;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        /*border-radius: 18px;*/
    }

    .dingdana {
        font-size: 18px;
        margin: 0 5px;
        background-color: azure;
        border: 1px solid red;
    }

    .price {
        font-size: 16px;
        color: #545c63;
        line-height: 24px;
        font-weight: 700;
        text-align: center;
    }

    .paypa {
        text-align: center;
    }

    .paypb {
        text-align: center;
        font-size: 14px;
        color: #9199a1;
        line-height: 24px;
        margin-top: 24px;
        cursor: pointer;
    }

    .paypb:hover {
        color: #545c63;
    }
</style>